const UpdatesActionTypes = {
	FETCH_UPDATES_START: 'FETCH_UPDATES_START',
	FETCH_UPDATES_SUCCESS: 'FETCH_UPDATES_SUCCESS',
	FETCH_UPDATES_FAILURE: 'FETCH_UPDATES_FAILURE'
}

export default UpdatesActionTypes;